import { Button } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const DownloadReport = styled.div``;

const DownloadReportInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 16px;
  margin-top: 24px;
`;

const InputGroup = styled.div`
  display: flex;
  position: relative;

  ${Button.S.Button} {
    ${({ isError }) =>
      isError &&
      css`
        bottom: 0.5rem;
      `}
  }
`;

export { DownloadReport, DownloadReportInputs, InputGroup };
